import {Component} from '@angular/core';
import { NavController, NavParams ,AlertController,ViewController ,ToastController} from 'ionic-angular';
import {Api} from "../../providers/api";
import {CartManager} from "../../providers/cart-manager";
import {MsgManager} from "../../providers/msg-manager";
import { UserManagementTabsPage} from "../user-management-tabs/user-management-tabs";
import {Events} from 'ionic-angular';
import { SpinnerDialog } from 'ionic-native';
import {GVLogger} from "../../services/gv-logger";
import {LoginPage} from "../login/login";


@Component({
  selector: 'users-add-popup',
  templateUrl: 'users-add-popup.html'
})
export class UsersAddPopup{



  user : any;
  callStatus = 0;
  tempUser:any;
  formStatus = false;
  buttonText = "";
  pageTitle = "";
  userUnique = true; // for update only
  role="";
  emailReadOnly= false;
  userNameReadOnly= false;
  isCreateCall = false;

	constructor(private nav:NavController,
    private api:Api,
    private params: NavParams,
    private cartManager:CartManager,
    private msgManager:MsgManager,
    private alertController:AlertController,
    private viewController:ViewController,
    private toastController:ToastController,
    private events:Events,
    private gVLogger: GVLogger){
		this.user = this.params.get("user");
    this.buttonText = this.params.get("button");


    if(this.user == null){
      this.user = {
        userId:0,
        roleId:3,
        phoneNo:"",
        externalAppId:""
      }
    }else{
      this.role = this.user.role+"";
    }

    this.tempUser = this.user;
    if(this.buttonText == "CREATE"){
      this.isCreateCall = true;
      this.pageTitle = "Create Sales App User";
      this.userUnique = false;

    }else{
      this.pageTitle = "Update Sales App User";
      this.userNameReadOnly = true;
      this.emailReadOnly = true;
    }


	}


  serverCall(){
    if(this.buttonText == "CREATE"){
      this.createCall();
    }else{
      this.updateCall();
    }
  }

  createCall(){

    this.validateForm();
    if(this.formStatus){
       this.gVLogger.log("Create Call...");
       SpinnerDialog.show(this.msgManager.getLoadingMsg());
       let body = this.genrateBody(0);
       this.gVLogger.log(body);
       this.api.post("users/addIntelliRepUser",body).map(res => res.json()).subscribe(result =>{
         if(result.status == "401"){ // check for session out
           this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
           this.nav.setRoot(LoginPage);
         }
         if(result.status == "200"){
          this.gVLogger.log("------if called--------");
           this.callStatus = 1;
           this.viewController.dismiss(this.returnData());
           this.toastMsg(result.message);
           this.events.publish("userDataChange");
         }else{
           this.gVLogger.log("-----------else called--------");
           this.user = this.tempUser;
           this.viewController.dismiss(this.returnData());
           this.toastMsg(result.message);
         }
         SpinnerDialog.hide();
       }, error =>{
         this.user = this.tempUser;
         this.toastMsg(this.msgManager.getWentWrongMsg());
         this.viewController.dismiss(this.returnData());
         SpinnerDialog.hide();
       });
    }else{
      this.toastMsg("Complete Form First.");
    }
  }

  updateCall(){
    this.validateForm();
    if(this.formStatus){
      this.gVLogger.log("Update Call...");
      SpinnerDialog.show(this.msgManager.getLoadingMsg());
      let body = this.genrateBody(0);
       this.gVLogger.log(body);
       this.api.post("users/editIntelliRepUser",body).map(res => res.json()).subscribe(result =>{
         if(result.status == "401"){ // check for session out
           this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
           this.nav.setRoot(LoginPage);
         }
         if(result.status == "200"){
           this.callStatus = 1;
           this.viewController.dismiss(this.returnData());
           this.toastMsg(result.message);
           this.events.publish("userDataChange");
         }else{
           this.user = this.tempUser;
           this.viewController.dismiss(this.returnData());
           this.toastMsg(result.message);
         }
         SpinnerDialog.hide();
       }, error =>{
         this.user = this.tempUser;
         this.toastMsg(this.msgManager.getWentWrongMsg());
         this.viewController.dismiss(this.returnData());
         SpinnerDialog.hide();
       });
    }else{
      this.toastMsg("Complete Form First.");
    }
  }

  genrateBody(isDeleted){

     let tempRestrictToAssignedCustomers = this.user.restrictToAssignedCustomers;
     tempRestrictToAssignedCustomers ? tempRestrictToAssignedCustomers = 1 : tempRestrictToAssignedCustomers = 0 ;

     let tempUserStatus = 0;
     if (this.user.isActive) {
       tempUserStatus = this.user.isActive;
       tempUserStatus ? tempUserStatus = 1 : tempUserStatus = 0;
     }

     let isDeletedTemp = isDeleted;



    return {
          userId: this.user.id,
          changeBy: this.cartManager.getSalesPerson().id,
          userName: this.user.userName,
          password: this.user.pass,
          // userStatus: tempState,
          userEmail: this.user.email,
          userFirstName: this.user.firstName,
          userLastName: this.user.lastName,
          userPhone: this.user.phoneNo,
          userRole: this.user.roleId,
          restrictToAssignedCustomers: tempRestrictToAssignedCustomers,
          externalAppId:this.user.externalAppId,
          userStatus: tempUserStatus,
          isDeleted: isDeletedTemp
    }
  }

  validateForm(){
    if( this.user.userName == "" ||
    this.user.password == "" ||
    this.user.email =="" ||
    this.user.password == "" ||
    this.user.phoneNo == "" ||
    this.user.roleId == ""){
      this.formStatus = false;
    }else{

      if(this.validEmail(this.user.email)){
          if(this.userUnique){
           this.formStatus = true;
          }else{
             let toast = this.toastController.create({
                  message: "User name not available please choose other.",
                  duration: 3000
                });
                toast.present();
           }

      }else{
          let toast = this.toastController.create({
                  message: "Invalid email",
                  duration: 3000
                });
                toast.present();
      }

  }
}

  cancelPopup(){
    //this.user = this.tempUser; // revert changes on cancel
    this.viewController.dismiss();
  }

  toastMsg(msg){
    let taost = this.toastController.create({
        message: msg,
        duration: 3000
    });
    taost.present();
  }

  returnData(){
    if (this.user.isActive == "1") {
      this.user.isActive = 1
    }else{
      this.user.isActive = 0
    }

    this.user.isActive ? this.user.isActive = 1 : this.user.isActive = 0;
    return {
      user: this.user,
      callStatus: this.callStatus
    }
  }



  checkUsernameUniqeness(){

    this.gVLogger.log(this.user.userName +" -- - - ");
   // var body:any = { "query":};

    // let body = new FormData();
    // body.append('query', this.user.userName );

    let body ={
      query:this.user.userName
    };

    this.api.get('customers/availability',body)
      .map(res => res.json())
        .subscribe(resp => {
          this.gVLogger.log(JSON.stringify(resp));
          if(resp.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.nav.setRoot(LoginPage);
          }
          if(resp.status=="200"){
            this.userUnique = true;

          }else if(resp.status=="500"){
            this.userUnique = false;
            let toast = this.toastController.create({
              message: "User name not available please choose other.",
              duration: 3000
            });
            toast.present();
          }
        });
  }


  deleteUser(){
    this.gVLogger.log("Delete Called");

  if (this.user.id == this.cartManager.getSalesManId()) {
    // let toast = this.toastController.create("Cannot delete self");
    // toast.present();

  } else {
    let confirm = this.alertController.create({
      title: 'Are you sure?',
      message: this.msgManager.getIntelliRepUserDeleteConfirm(),
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            this.gVLogger.log('Disagree clicked');
          }
        },
        {
          text: 'Delete',
          handler: () => {
            this.gVLogger.log('Agree clicked');
            let body = this.genrateBody(1);
            this.api.post("/users/deleteIntelliRepUser", body).map(res => res.json()).subscribe(result => {

              if(result.status == "401"){ // check for session out
                this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
                this.nav.setRoot(LoginPage);
              }
              if (result.status == "200") {
                this.gVLogger.log("Deleted User Successfully");
                let toast = this.toastController.create({message: "Deleted User Successfully",
                duration: 3000});
                toast.present();
                 this.viewController.dismiss(null).then(()=>{
                   // setTimeout(()=>{
                   //   this.events.publish("userDataChange");
                   // },10000);
                 });
                 this.events.publish("userDataChange");

               // this.nav.setRoot(UserManagementTabsPage).then(()=>{
               //   this.usertabs.select(1);
               // });
              }

            });


          }
        }
      ]
    });
    confirm.present();

  }


  }







  validEmail(e) {
    var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
    return String(e).search (filter) != -1;
}



}



// WEBPACK FOOTER //
// ./src/pages/users-add-popup/users-add-popup.ts